import { observer } from 'mobx-react';
import * as React from 'react';

import { ClientLogger } from 'bernie-client';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

import { HotelMapModel, PropertyLocationViewModel } from 'models';

import { UitkCard, UitkCardContent } from 'uitk-react-cards';

import { LocationHeader } from 'components/infosite/property-details/property-location/internals/location-header';
import { LocationStreetAddress } from 'components/infosite/property-details/property-location/internals/location-street-address';
import { WhatsAroundMap } from 'components/infosite/whats-around/whats-around-map';

export interface PropertyLocationProps {
  mapModel?: HotelMapModel;
  propertyLocationInfo?: PropertyLocationViewModel;
}

@observer
export class PropertyLocation extends React.Component<PropertyLocationProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { mapModel, propertyLocationInfo } = this.props;

    if (!propertyLocationInfo) {
      return null;
    }

    return (
      <div className="all-y-margin-three" data-stid="hotel-detailed-location">
        <UitkCard>
          <UitkCardContent className="uitk-grid uitk-cell">
            <LocationHeader
              title={propertyLocationInfo.title}
              className="s-cell-1-1 l-cell-1-3 xl-cell-1-3 s-t-padding-three l-t-padding-six xl-t-padding-six
              s-l-padding-three l-l-padding-six xl-l-padding-six"
            />
            <Map
              contentClassName="s-cell-1-1 l-cell-2-3 xl-cell-2-3 all-b-padding-six
              l-x-padding-three xl-x-padding-three l-t-padding-three xl-t-padding-three"
              mapModel={mapModel}
              propertyLocationInfo={propertyLocationInfo}
            />
          </UitkCardContent>
        </UitkCard>
      </div>
    );
  }
}

interface MapProps extends PropertyLocationProps {
  contentClassName: string;
}

const Map: React.FunctionComponent<MapProps> = ({ contentClassName, mapModel, propertyLocationInfo }) => {
  const mapImageUrl = propertyLocationInfo.mapImageUrl;
  const logger = ClientLogger.getLoggerWithIdentifier('pwa.component.property-location');
  if (mapImageUrl && logger && typeof logger.logEvent === 'function') {
    logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'SDUI_HOTEL_DETAILED_LOCATION_MAP_LOADED'));
  }

  return (
    <div className={`uitk-cell ${contentClassName}`}>
      {mapImageUrl && (
        <div data-stid="property-location-map" className="all-cell-1-1 all-x-margin-three all-y-margin-three">
          <WhatsAroundMap src={mapImageUrl} rfrr=":HotelDetailedLocationMap.Open" mapModel={mapModel} />
        </div>
      )}
      {propertyLocationInfo.streetAddress && <LocationStreetAddress propertyLocationInfo={propertyLocationInfo} />}
    </div>
  );
};
